import { RefObject, useEffect } from "react";

export default function useOnClickOutside(
  ref: RefObject<HTMLDivElement>,
  handler: () => void
) {
  useEffect(() => {
    const listener = ({ target }: { target: Node | null }) => {
      if (!ref.current || ref.current.contains(target)) return;

      handler();
    };
    document.addEventListener("mousedown", listener as EventListener);
    document.addEventListener("touchstart", listener as EventListener);
    return () => {
      document.removeEventListener("mousedown", listener as EventListener);
      document.removeEventListener("touchstart", listener as EventListener);
    };
  }, [ref, handler]);
}
